import { VisibilityConditionCombiningOperationEnum } from "@genesys/cloud-frontend/dist/mjs/models";
import { useStrings } from "features/i18n/useStrings";
import {
    GuxDropdown,
    GuxListbox,
    GuxOption,
} from "genesys-spark-components-react";
import strings from "./ConditionCombiningOperatorDropDown.strings";

export default function ConditionCombiningOperatorDropDown({
    visibilityConditionOperator,
    onUpdate,
}: {
    visibilityConditionOperator: VisibilityConditionCombiningOperationEnum;
    onUpdate: (
        conditionalOperator: VisibilityConditionCombiningOperationEnum
    ) => void;
}) {
    const t = useStrings(strings);

    return (
        <GuxDropdown
            value={visibilityConditionOperator}
            onInput={(e) => {
                const conditionalOperator = (e.target as HTMLInputElement)
                    .value as VisibilityConditionCombiningOperationEnum;
                onUpdate(conditionalOperator);
            }}
            data-testid="visibility-condition-operator-dropdown"
        >
            <GuxListbox aria-label={t.labels.dropDownOptions}>
                {Object.values(VisibilityConditionCombiningOperationEnum).map(
                    (operator) => (
                        <GuxOption
                            key={operator}
                            value={operator}
                            data-testid={operator}
                        >
                            {t.labels.visibilityConditionOperators[operator]}
                        </GuxOption>
                    )
                )}
            </GuxListbox>
        </GuxDropdown>
    );
}
